import React from 'react';
import ReactDOM from 'react-dom/client';
import {DSN} from "./settings/local_settings";
import * as Sentry from "@sentry/react";
import {RouterProvider} from "react-router-dom";
import {router} from "./routes";
import './i18n';
import {sentryBeforeSend} from './utils/sentryBeforeSend';

// Ensure any previously registered service workers (from old deployments)
// are unregistered so they don't serve stale cached assets when switching
// hosting/origin (e.g., Compute Engine -> Cloud Run).
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
    }).finally(() => {
        if (window.caches && caches.keys) {
            caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
        }
    });
}

Sentry.init({
  dsn: DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Sin el token del link del vendedor, sin los fallos de red de una pestaña sin conexión y sin nada
  // de una ventana donde el QA trucó el `fetch`: ver `src/utils/sentryBeforeSend.js`.
  beforeSend: sentryBeforeSend,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>
    </React.StrictMode>
);
